export default __webpack_public_path__ + "static/media/DJI.4aa05390.svg";